import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { CrudService } from "src/app/components/shared/cruds/crud.service";

@Injectable({ providedIn: "root" })
export class AlertasService extends CrudService<any> {
  protected controller: string = "alertas/";

  public getDefiniciones(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/${this.controller}getDefiniciones`
    );
  }
  public getProgramadas(i: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/${this.controller}getProgramadas`,
      { params: { i } }
    );
  }
  public deleteProgramada(i: string): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
      params: { i },
    };
    return this.http.get<any>(
      `${environment.serverUrl}api/${this.controller}removeProgramada`,
      options
    );
  }
}
